import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

import storePlugin from "@/plugins/storePlugin";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [storePlugin],
  state: {
    authenticated_profile: null,
    acl_map: {},
    did_auto_logout: false,
    logged: false,
    cant_action: null,
    main_loader: true,
    try_login_one_time: false,

    openEditImgs: 0,

    fake_experiences: [
      {
          "label": "Volantinaggio",
          "label_en": null,
          "value": "Volantinaggio"
      },
      {
          "label": "Promoter",
          "label_en": null,
          "value": "Promoter"
      },
      {
          "label": "Hostess",
          "label_en": null,
          "value": "Hostess"
      },
      {
          "label": "Immagine",
          "label_en": null,
          "value": "Immagine"
      },
      {
          "label": "Showroom",
          "label_en": null,
          "value": "Showroom"
      },
      {
          "label": "Fotomodello",
          "label_en": null,
          "value": "Fotomodello"
      },
      {
          "label": "Sfilate",
          "label_en": null,
          "value": "Sfilate"
      },
      {
          "label": "Ballerino",
          "label_en": null,
          "value": "Ballerino"
      },
      {
          "label": "Cameriere",
          "label_en": null,
          "value": "Cameriere"
      },
      {
          "label": "Barman",
          "label_en": null,
          "value": "Barman"
      },
      {
          "label": "Supervisor",
          "label_en": null,
          "value": "Supervisor"
      },
      {
          "label": "Interprete",
          "label_en": null,
          "value": "Interprete"
      },
      {
          "label": "Presentatrice",
          "label_en": null,
          "value": "Presentatrice"
      },
      {
          "label": "Musicista",
          "label_en": null,
          "value": "Musicista"
      },
      {
          "label": "Attore",
          "label_en": null,
          "value": "Attore"
      },
      {
          "label": "Animatore",
          "label_en": null,
          "value": "Animatore"
      },
      {
          "label": "Stylist",
          "label_en": null,
          "value": "Stylist"
      },
      {
          "label": "Makeup",
          "label_en": null,
          "value": "Makeup"
      },
      {
          "label": "Allestitore",
          "label_en": null,
          "value": "Allestitore"
      },
      {
          "label": "Merchandiser",
          "label_en": null,
          "value": "Merchandiser"
      },
      {
          "label": "Driver",
          "label_en": null,
          "value": "Driver"
      },
      {
          "label": "Fotografo",
          "label_en": null,
          "value": "Fotografo"
      },
      {
          "label": "Doorman",
          "label_en": null,
          "value": "Doorman"
      },
      {
          "label": "Dj",
          "label_en": null,
          "value": "Dj"
      },
      {
          "label": "Hair",
          "label_en": null,
          "value": "Hair"
      }
  ],

    /* LOADING */
    loading_data: false,
  },
  getters,
  mutations,
  actions
});
